import { Response } from "@/types/response/Response";
import { UserDTO } from "@/types/user/UserDTO";
import ApiUtils from "@/lib/ApiUtils";
import { createApi, RootState } from "@reduxjs/toolkit/query/react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

export const userApiV1 = createApi({
  reducerPath: "_user",
  baseQuery: ApiUtils.apiQuery("/v1"),
  tagTypes: ["_self_user"],
  endpoints: (builder) => ({
    getSelfUser: builder.query<Response<UserDTO>, Partial<void>>({
      query: () => "/users/self",
      providesTags: ["_self_user"],
    }),
  }),
});

export const selectSelfUser = (state: RootState<any, any, any>) =>
  userApiV1.endpoints?.getSelfUser?.select()(state);

export const useGetPermissions = (): UserDTO["permissions"] | undefined =>
  useSelector(
    createSelector(selectSelfUser, (user) => user.data?.data?.permissions)
  );

export const { useGetSelfUserQuery } = userApiV1;
